var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAffordable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 32.5,
    cy: 32.5,
    r: 32.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#EB77A1",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#EA696A",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.169 39.255L27.349 45v-5.745h-3.872A1.477 1.477 0 0 1 22 37.778V25.477c0-.816.661-1.477 1.477-1.477h19.235c.815 0 1.477.661 1.477 1.477v12.3c0 .816-.662 1.478-1.477 1.478h-7.543z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffordable);
export default __webpack_public_path__ + "static/media/affordable.0d343d974581dacfd8e3b0bd81f53998.svg";
export { ForwardRef as ReactComponent };